import React from "react";
import PartnerBadge from "@/components/badges/PartnerBadge";

export function BadgesRow() {
  const IconShield = (p) => (<svg viewBox="0 0 24 24" {...p}><path fill="currentColor" d="M12 2 4 5v6c0 5 3.4 9.7 8 11 4.6-1.3 8-6 8-11V5z"/></svg>);
  const IconStar = (p) => (<svg viewBox="0 0 24 24" {...p}><path fill="currentColor" d="m12 17.27-5.18 3.05 1.64-5.64L3 10.24l5.91-.51L12 4l3.09 5.73 5.91.51-5.46 4.44 1.64 5.64z"/></svg>);
  const IconBox = (p) => (<svg viewBox="0 0 24 24" {...p}><path fill="currentColor" d="M12 2 2 7l10 5 10-5z"/><path fill="currentColor" d="M2 17l10 5 10-5V9l-10 5L2 9z"/></svg>);

  const badges = [
    { icon: <IconStar className="h-4 w-4" />, text: "Partenaire Amazon (Ads/SPN)", accent: true, isAmazon: false },
    { icon: <IconBox className="h-4 w-4" />, text: "SPN", accent: false, isAmazon: false },
    { icon: <IconShield className="h-4 w-4" />, text: "SP-API & conformité données", accent: true, isAmazon: false },
  ];
  return (
    <div className="w-full py-6">
      <div className="mx-auto max-w-6xl px-4">
        <div className="flex flex-wrap items-center justify-center gap-4">
          <span className="rounded-full bg-primary/20 border-2 border-primary/30 px-6 py-2 text-sm font-medium text-primary shadow-lg backdrop-blur-sm flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-gradient-to-r from-yellow-400 to-orange-400 shadow-lg shadow-yellow-400/50 animate-pulse"></span>
            Amazon Verified Partner
          </span>
          <span className="rounded-full bg-transparent border-2 border-primary/30 px-6 py-2 text-sm font-medium text-primary">
            Amazon Ads
          </span>
        </div>
      </div>
    </div>
  );
}